import api from './api'

const productAdvanceDataProvider = {
  getCategories(params = {}) {
    return api.query('Product/api/Category/GetCategoryChildren', { params })
  },
  getBrands(params = {}) {
    return api.query('Product/api/Brand/GetBrands', { params })
  },
  getColors(params = {}) {
    return api.query('Product/api/Color/GetMany', { params })
  },
  getGuarantees(params = {}) {
    return api.query('Product/api/Guarantee/GetMany', { params })
  },
  getSize(params = {}) {
    return api.query('Product/api/Size/GetMany', { params })
  },
  createBrand(params) {
    return api.post('Product/api/Brand/CreateBrand', params)
  },
  addGurantee(params) {
    return api.post('Product/api/Guarantee/AddOne', params)
  },
  addSize(params) {
    return api.post('Product/api/Size/AddSize', params)
  },
  addColor(params) {
    return api.post('Product/api/Color/AddOne', params)
  },
  getColorDetail(params = {}) {
    return api.query('Product/api/Color/GetOne', { params })
  },
  getGuranteeDetail(params = {}) {
    return api.query('Product/api/Guarantee/GetOne', { params })
  },
  getSizeDetail(params = {}) {
    return api.query('Product/api/Size/GetOne', { params })
  },
  editSize(params) {
    return api.put('Product/api/Size/UpdateOne', params)
  },
  editColor(params) {
    return api.put('Product/api/Color/UpdateOne', params)
  },
  editGuarantee(params) {
    return api.put('Product/api/Guarantee/UpdateOne', params)
  },
  getProductStockTable(params) {
    return api.post('Product/api/Product/GetProductStockTable', params)
  },
  createProduct(params) {
    return api.post('Product/api/Product/AddProduct', params)
  },
  getProductAdvanceDetail(params) {
    return api.query(`Product/api/Product/GetProductByIdForAdmin/${params}`)
  },
  getCategoryFormBuilderWithId(params = {}) {
    return api.query('Product/api/Category/GetCategoryFormWitRecords', { params })
  },
  getCategoryProperties(params = {}) {
    return api.query('Product/api/Category/GetCategoryProperties', { params })
  },
  editProductByGuid(params) {
    return api.put('Product/api/Product/EditProduct', params)
  },
  deleteProduct(params = {}) {
    return api.delete('Product/api/Product/DeleteProduct', { params })
  },
  editStock(params) {
    return api.put('Product/api/Product/EditStock', params)
  },
  getCustomer(params = {}) {
    return api.query('People/api/People', {
      params,
    })
  },
}

export default productAdvanceDataProvider
